import { get } from "lodash";
import React from "react";
import { connect } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router-dom";

import StatusBadgeV2 from "../../components/StatusBadgeV2/StatusBadgeV2";
import { renderTimeSpan } from "../../components/Table/columnRenders";
import * as S from "../../constants/StringConstants";
import { IProposalRecord } from "../../store/models/proposal.model";
import { IRootState } from "../../store/reducers";
import {
  fetchProductTypeList,
  fetchProposal,
  fetchStatusList,
  saveProposalClone,
} from "../../store/reducers/proposalOptions";
import { fetchProposalsList } from "../../store/reducers/proposals";

import ProductTypeFilterTool from "../../components/TableV2/ProductTypeFilter";
import DisTable from "../../components/TableV2/Table";

import { Form } from "react-final-form";
import AppBar from "src/components/AppBar/AppBar";
import GuardedComponent from "src/components/GuardedComponent/GuardedComponent";
import Icon, { IconName } from "src/components/Icon/Icon";
import FilterContainer from "src/components/TableV2/FilterContainer";
import StatusFilter from "src/components/TableV2/StatusFilter";
import Title from "src/components/TableV2/Title";
import { LoadingContextType, withLoading } from "src/hooks/useLoading";
import { UserRole } from "src/store/models/user.model";
import { convertFromProposal } from "src/store/reducers/applications";
import { generateProposalClone } from "src/util/util.cloneProposal";
import { openUrl } from "src/util/util.navigation";
import SearchFieldTool from "../../components/TableV2/SearchField";
import { TableActions } from "../../components/TableV2/TableActions";
import { addDefaultOption } from "../../util/utils.defaultValues";
import { ConvertModal } from "./ConvertModal";

import "./Proposals.scss";

export interface IProposalTableAllProps extends StateProps, DispatchProps, RouteComponentProps, LoadingContextType {}

export class Proposals extends React.Component<IProposalTableAllProps, { selectedProposal?: number }> {
  constructor(props) {
    super(props);
    this.state = {
      selectedProposal: null,
    };
    this.toggleOpen = this.toggleOpen.bind(this);
    this.handleModalDismiss = this.handleModalDismiss.bind(this);
    this.handleModalAccept = this.handleModalAccept.bind(this);
  }

  async componentDidMount() {
    this.props.setIsLoading(true);
    await this.props.fetchStatusList();
    await this.props.fetchProductTypeList();
    this.props.setIsLoading(false);
  }

  toggleOpen() {
    this.setState({ selectedProposal: null });
  }

  handleModalDismiss() {
    this.setState({ selectedProposal: null });
  }

  async handleModalAccept(proposalID, carrierTypeID, occupationClassTypeID, designTypeID, productName, fileIdList) {
    this.props.setIsLoading(true);
    const res: any = await this.props.convertFromProposal(
      proposalID,
      carrierTypeID,
      occupationClassTypeID,
      designTypeID,
      productName,
      fileIdList,
    );
    this.props.setIsLoading(false);
    this.props.history.push(`/applications/${res.value.data}`);
    this.handleModalDismiss();
  }

  async clone(proposalID: number) {
    try {
      this.props.setIsLoading(true);
      await this.props.fetchProposal(String(proposalID)); // fetch the proposal first

      const { proposalMap } = this.props;
      const proposal = proposalMap[proposalID];

      if (!proposal) return;

      const clonedProposal = generateProposalClone(proposal);
      const result = await this.props.saveProposalClone(clonedProposal);
      const newId = get(result, "value.data.proposalID");

      if (newId) {
        window.open(`/proposals/${newId}/details`);
      }
    } catch (error) {
    } finally {
      this.props.setIsLoading(false);
    }
  }
  render() {
    const {
      fetchProposalsList,
      proposals: { map, projection, total, listOptions },
      statusList,
      productTypeList,
      proposalMap,
    } = this.props;

    const statusOptions = addDefaultOption(S.PRO_ALL, statusList);
    const productTypeOptions = addDefaultOption(S.PRO_ALL, productTypeList);

    const columns = [
      {
        key: "receivedDateDisplay",
        title: S.PRO_COL_RECEIVED_DATE,
        style: { minWidth: "11rem" },
      },
      {
        key: "timeSpan",
        title: S.PRO_COL_TIME,
        render: renderTimeSpan,
        style: { minWidth: "11rem" },
      },
      {
        key: "productTypeAbbreviation",
        title: S.PRO_COL_PRODUCT_TYPE,
        style: { minWidth: "8rem" },
      },
      {
        key: "proposalID",
        title: S.PRO_COL_PROPOSAL,
        render: item => {
          if (item.fromIOLandingPage) {
            return <div className="fromIOLandingPage">{item.proposalID}</div>;
          } else if (item.fromBrokerQuoteEngine) {
            return <div className="fromBrokerQuoteEngine">{item.proposalID}</div>;
          } else if (item.fromIncomologist) {
            return <div className="fromIncomologist">{item.proposalID}</div>;
          } else {
            return item.proposalID;
          }
        },
        style: { minWidth: "8rem" },
      },
      {
        key: "revisionNumber",
        title: S.PRO_COL_REV,
        style: { minWidth: "5rem" },
      },
      {
        key: "branch",
        title: S.PRO_COL_BRANCH,
        style: { minWidth: "8rem" },
        sortKey: "Branch",
      },
      {
        key: "affiliate",
        title: S.PRO_COL_AFFILIATE,
        style: { minWidth: "7rem" },
      },
      {
        key: "memberCompany",
        title: S.PRO_COL_MEMBER,
        style: { minWidth: "12rem" },
        sortKey: "MemberCompany",
      },
      {
        key: "brokerName",
        title: S.PRO_COL_BROKER,
        style: { minWidth: "10rem", width: "10rem" },
      },
      {
        key: "clientName",
        title: S.PRO_COL_CLIENT,
        render: item => {
          if (item.isMultiLife) {
            return (
              <div>
                <i className="icon icon--client" /> {S.PRO_COL_MULTI_LIFE}
              </div>
            );
          } else {
            return item.clientName;
          }
        },
        style: { minWidth: "8rem" },
      },
      {
        key: "specialistName",
        title: S.PRO_COL_PROPOSAL_SPECIALIST,
        style: { minWidth: "8rem" },
      },
      {
        key: "status",
        title: S.PRO_COL_STATUS,
        render: item => <StatusBadgeV2 status={item.status} />,
      },
      {
        key: "actions",
        title: S.PRO_COL_ACTIONS,
        render: item => {
          return (
            <TableActions
              actions={[
                {
                  label: S.PC_CONVERT,
                  handler: () => {
                    this.setState({ selectedProposal: item.proposalID });
                  },
                },
                {
                  label: S.PC_PROPOSAL_CLONE_BUTTON,
                  handler: () => {
                    this.clone(item.id);
                  },
                },
              ]}
            />
          );
        },
      },
    ];

    return (
      <div className="table-view-v2__content">
        <div className="table-view__header-buttons-container">
          <AppBar icon={IconName.Proposals} title={S.PRO_PAGE_TITLE} loading={this.props.isLoading}>
            <div className="table-view__buttons-container">
              <GuardedComponent
                authorizedRoles={[
                  UserRole.Admin,
                  UserRole.ProposalSpecialist,
                  UserRole.RegionalBranchManager,
                  UserRole.BranchManager,
                  UserRole.UnderwritingAssociate,
                  UserRole.IOSpecialist,
                ]}>
                <button className="side-nav__add-button" onClick={() => openUrl("/proposals/new/ml/details", true)}>
                  <Icon name={IconName.Plus} />
                  {S.NEW_PROPOSAL_ML}
                </button>
                <button className="side-nav__add-button" onClick={() => openUrl("/proposals/new/details", true)}>
                  <Icon name={IconName.Plus} />
                  {S.NEW_PROPOSAL}
                </button>
              </GuardedComponent>
            </div>
          </AppBar>
        </div>

        <DisTable<IProposalRecord>
          columns={columns}
          initialState={{ rows: 25, map, projection, total, ...listOptions }}
          onUpdate={async ({ page, rows, sort, query }) => {
            this.props.setIsLoading(true);
            const result: any = await fetchProposalsList({ page, rows, sort, query });
            this.props.setIsLoading(false);
            return {
              total: get(result, "value.data.totalRows") as number,
              data: get(result, "value.data.items") as IProposalRecord[],
            };
          }}
          onRowClick={(data: IProposalRecord) => {
            window.open(`/proposals/${data.proposalID}/details`);
          }}>
          <Form
            initialValues={{}}
            onSubmit={() => {}}
            render={({ handleSubmit, valid }) => (
              <FilterContainer
                left={<Title text={S.PRO_PAGE_TITLE} />}
                right={
                  <>
                    <SearchFieldTool />
                    <ProductTypeFilterTool productTypeList={productTypeOptions} />
                    <StatusFilter statusList={statusOptions} />
                  </>
                }
              />
            )}
          />
        </DisTable>

        <ConvertModal
          open={this.state.selectedProposal !== null}
          proposalID={this.state.selectedProposal}
          handleConfirm={this.handleModalAccept}
          handleReject={this.handleModalDismiss}
        />
      </div>
    );
  }
}

const mapStateToProps = ({ proposals, proposalOptions: { statusList, productTypeList, proposalMap } }: IRootState) => ({
  proposals,
  statusList,
  productTypeList,
  proposalMap,
});

const mapDispatchToProps = {
  fetchProposalsList,
  fetchStatusList,
  fetchProductTypeList,
  convertFromProposal,
  saveProposalClone,
  fetchProposal,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withLoading(Proposals)));
